{
  "reference": "Reference",
  "generic": {
    "title": "Something went wrong",
    "detail": "Try again. If it keeps happening, contact support and quote the reference."
  },
  "status": {
    "400": {
      "title": "Bad request",
      "detail": "Check the details and try again."
    },
    "401": {
      "title": "Sign in to continue",
      "detail": "Your session ended or you are not signed in."
    },
    "403": {
      "title": "You don't have access",
      "detail": "Your team role doesn't allow this. Ask an owner or admin."
    },
    "404": {
      "title": "Not found",
      "detail": "We couldn't find what you're looking for. It may have been removed or moved."
    },
    "409": {
      "title": "Conflict",
      "detail": "This changed somewhere else. Refresh the page and try again."
    },
    "422": {
      "title": "Check the fields",
      "detail": "Some fields need a correction."
    },
    "429": {
      "title": "Too many requests",
      "detail": "Wait a moment and try again."
    },
    "500": {
      "title": "Something went wrong on our side",
      "detail": "Try again shortly."
    }
  },
  "codes": {
    "network_error": {
      "title": "Can't connect",
      "detail": "Check your internet connection and try again."
    },
    "invalid_credentials": {
      "title": "Wrong email or password",
      "detail": "Check them and try again, or ask for a link to set a new password."
    },
    "email_not_verified": {
      "title": "Verify your email first",
      "detail": "We sent you a verification link when you signed up. Open it, then sign in."
    },
    "session_expired": {
      "title": "Session expired",
      "detail": "Sign in again to continue."
    },
    "unauthenticated": {
      "title": "Sign in to continue",
      "detail": "You need to sign in to see this page."
    },
    "forbidden": {
      "title": "You don't have access",
      "detail": "Your team role doesn't allow this. Ask an owner or admin."
    },
    "not_found": {
      "title": "Not found",
      "detail": "We couldn't find what you're looking for. It may have been removed or moved."
    },
    "server_not_found": {
      "title": "We couldn't find this server",
      "detail": "It may have been removed or belong to another company."
    },
    "invalid_token": {
      "title": "This link isn't valid",
      "detail": "Make sure you opened the full link from the latest email."
    },
    "token_expired": {
      "title": "This link has expired",
      "detail": "Email confirmation links last 24 hours and password reset links last 1 hour. Ask for a new one."
    },
    "token_used": {
      "title": "This link was already used",
      "detail": "Sign in, or ask for a new link."
    },
    "challenge_expired": {
      "title": "The code timed out",
      "detail": "Go back to sign in and start again."
    },
    "validation_failed": {
      "title": "Check the fields",
      "detail": "Some fields need a correction."
    },
    "no_organization": {
      "title": "No company linked to your account",
      "detail": "Ask the account owner to send you an invitation."
    },
    "internal_error": {
      "title": "Something went wrong on our side",
      "detail": "Try again shortly."
    },
    "not_implemented": {
      "title": "Not available yet",
      "detail": "This action isn't available in this version."
    },
    "payment_method_required": {
      "title": "No saved payment method",
      "detail": "Your payment method is saved with your first payment. Pay first, then try again."
    },
    "trial_server_limit": {
      "title": "You've reached the trial server limit",
      "detail": "The free trial covers up to 3 servers. You can add more once your paid subscription starts."
    },
    "downgrade_capacity_exceeded": {
      "title": "More hosting accounts than the plan allows",
      "detail": "Remove or move some accounts off the server first, or choose a bigger plan."
    },
    "plan_unchanged": {
      "title": "That's your current plan",
      "detail": "Choose a different plan or billing cycle."
    },
    "server_cancelling": {
      "title": "This server's subscription is set to end",
      "detail": "Undo the cancellation first, then change the plan."
    },
    "server_not_cancelling": {
      "title": "This subscription isn't cancelled",
      "detail": "This server's subscription renews automatically."
    },
    "server_not_pending": {
      "title": "This server is already active",
      "detail": "This action is only for servers waiting for activation."
    },
    "server_pending_use_remove": {
      "title": "This server isn't active yet",
      "detail": "There's no paid subscription to cancel. Remove the server instead."
    },
    "transfer_in_progress": {
      "title": "A transfer is already in progress",
      "detail": "Wait until the old installation stops, then try again."
    },
    "transfer_not_allowed": {
      "title": "Transfer isn't available right now",
      "detail": "You can transfer a server while its subscription is active or on trial. Pay the amount due first."
    },
    "transfer_too_soon": {
      "title": "This server was transferred recently",
      "detail": "A server can be transferred once every 30 days. The next transfer is possible on {{date}}. Contact support if you need it sooner."
    },
    "device_code_not_found": {
      "title": "We don't recognise this code",
      "detail": "Check that you typed the code exactly as the server shows it."
    },
    "device_code_expired": {
      "title": "This code has expired",
      "detail": "Codes last 15 minutes. Run the install command again to get a new one."
    },
    "device_code_used": {
      "title": "This code was already used",
      "detail": "Each code works once. Run the install command again to get a new one."
    },
    "member_not_found": {
      "title": "We couldn't find this member",
      "detail": "They may have been removed. Refresh the page."
    },
    "owner_role_locked": {
      "title": "The owner's role can't change",
      "detail": "To change the owner, transfer ownership from the team page."
    },
    "cannot_change_own_role": {
      "title": "You can't change your own role",
      "detail": "Ask the owner or another admin to change it."
    },
    "owner_cannot_leave": {
      "title": "The owner can't leave",
      "detail": "Transfer ownership to another member first, then you can leave."
    },
    "owner_cannot_be_removed": {
      "title": "The owner can't be removed",
      "detail": "The owner stays on the team until ownership is transferred."
    },
    "already_owner": {
      "title": "You're the owner",
      "detail": "Choose another member to transfer ownership to."
    },
    "transfer_requires_2fa": {
      "title": "The new owner needs two-factor authentication",
      "detail": "Ask them to turn it on in settings, then try again."
    },
    "invitation_not_found": {
      "title": "We couldn't find this invitation",
      "detail": "It may have been accepted or revoked. Refresh the page."
    },
    "invite_recently_sent": {
      "title": "We sent this invitation moments ago",
      "detail": "Wait a minute before sending it again."
    },
    "too_many_invitations": {
      "title": "Too many open invitations",
      "detail": "Revoke some older invitations before sending new ones."
    },
    "two_factor_required_to_enforce": {
      "title": "Turn on two-factor authentication for yourself first",
      "detail": "You can't require something for the team you haven't set up yourself."
    },
    "invitation_used": {
      "title": "This invitation was already used",
      "detail": "It has been accepted. Sign in to continue."
    },
    "invitation_revoked": {
      "title": "This invitation was revoked",
      "detail": "Ask the account owner or an admin for a new one."
    },
    "invitation_expired": {
      "title": "This invitation has expired",
      "detail": "Invitations last 7 days. Ask for a new one."
    },
    "invitation_email_mismatch": {
      "title": "This invitation is for another email",
      "detail": "Sign out and sign in with the address the invitation was sent to."
    },
    "account_exists": {
      "title": "You already have an account with this email",
      "detail": "Sign in to accept the invitation."
    },
    "ticket_not_found": {
      "title": "We couldn't find this ticket",
      "detail": "The link may be old or the ticket belongs to another organisation."
    },
    "ticket_reopen_window_passed": {
      "title": "This ticket was resolved more than 14 days ago",
      "detail": "Open a new ticket and mention this ticket's number."
    },
    "ticket_not_resolved": {
      "title": "This ticket is still open",
      "detail": "You can rate support once the ticket is resolved."
    },
    "ticket_already_rated": {
      "title": "You already rated this ticket",
      "detail": "Thanks, we have your rating."
    },
    "diagnostics_unavailable": {
      "title": "No diagnostics available",
      "detail": "The server hasn't checked in yet, so we have no data from it."
    },
    "release_not_found": {
      "title": "We couldn't find this release",
      "detail": "The version may be wrong or not published yet."
    },
    "two_factor_already_on": {
      "title": "Two-factor authentication is already on",
      "detail": "Your account is protected, so there's nothing to set up again."
    },
    "two_factor_setup_expired": {
      "title": "The setup timed out",
      "detail": "Start setting up two-factor authentication again."
    },
    "two_factor_required_by_org": {
      "title": "Your organisation requires two-factor authentication",
      "detail": "You can't turn it off while an organisation you belong to requires it."
    },
    "two_factor_off": {
      "title": "Two-factor authentication is off",
      "detail": "Turn it on first to get recovery codes."
    },
    "session_not_found": {
      "title": "We couldn't find this session",
      "detail": "It may have ended already. Refresh the list."
    },
    "cannot_revoke_current_session": {
      "title": "This is your current session",
      "detail": "Use sign out in the user menu to end it."
    },
    "preference_locked": {
      "title": "This notification is required",
      "detail": "You can't turn off this email for your role."
    },
    "org_has_active_servers": {
      "title": "There are active servers",
      "detail": "Cancel every server's subscription before deleting the organisation."
    },
    "org_has_balance": {
      "title": "There's an amount due",
      "detail": "Pay the amount due before deleting the organisation."
    },
    "email_taken": {
      "title": "This email is already in use",
      "detail": "Use a different email."
    },
    "invoice_not_found": {
      "title": "Invoice not found",
      "detail": "It may have been removed, or it belongs to another organisation."
    },
    "invoice_not_payable": {
      "title": "This invoice can't be paid",
      "detail": "It's already paid, void or refunded."
    },
    "payment_method_not_found": {
      "title": "Payment method not found",
      "detail": "It may have been removed. Refresh and pick another one."
    },
    "payment_method_required_for_subscriptions": {
      "title": "Keep at least one payment method",
      "detail": "Your active subscriptions renew with a saved payment method. Add another before removing this one."
    },
    "payment_method_limit": {
      "title": "You've reached the limit",
      "detail": "You can save up to 5 payment methods. Remove one before adding another."
    },
    "payment_method_duplicate": {
      "title": "This payment method is already saved",
      "detail": "Pick it from your payment methods instead."
    },
    "payment_method_expired": {
      "title": "This card has expired",
      "detail": "Choose another payment method or add a new card."
    },
    "payment_not_found": {
      "title": "Payment not found",
      "detail": "Refresh the page and check your payments."
    },
    "subscription_not_found": {
      "title": "Subscription not found",
      "detail": "It may belong to a removed server."
    },
    "subscription_past_due": {
      "title": "Pay the renewal first",
      "detail": "The renewal payment didn't go through. Pay it, then change the plan."
    },
    "subscription_cancel_scheduled": {
      "title": "This subscription is set to end",
      "detail": "Undo the cancellation first, then change the plan."
    },
    "no_scheduled_change": {
      "title": "No scheduled change",
      "detail": "There's no plan change waiting on this subscription."
    },
    "ai_unavailable": {
      "title": "AI isn't available on this server",
      "detail": "The server isn't activated yet, its control panel is locked, or it has been offline for a while. You can buy credits once that's sorted."
    },
    "checkout_cancelled": {
      "title": "Payment cancelled",
      "detail": "This checkout session was cancelled. Start the payment again."
    },
    "checkout_completed": {
      "title": "Already paid",
      "detail": "This checkout session is already complete."
    },
    "checkout_expired": {
      "title": "This checkout session has expired",
      "detail": "Nothing was charged. Start the payment again."
    },
    "checkout_not_found": {
      "title": "Checkout session not found",
      "detail": "Start the payment again."
    },
    "checkout_not_needed": {
      "title": "Nothing to pay now",
      "detail": "Refresh the page and check the subscription."
    },
    "checkout_required": {
      "title": "This needs a payment",
      "detail": "Continue to payment to finish the change."
    },
    "payment_already_set_up": {
      "title": "Payment is already set up",
      "detail": "A payment method is saved for this subscription. You can change it from Manage payment methods."
    },
    "portal_session_expired": {
      "title": "This portal session has expired",
      "detail": "Go back to bPanel and open Manage payment methods again."
    },
    "portal_session_not_found": {
      "title": "Portal session not found",
      "detail": "Go back to bPanel and open Manage payment methods again."
    },
    "purchase_not_found": {
      "title": "Purchase not found",
      "detail": "Refresh the page and check your credit purchases."
    },
    "server_locked": {
      "title": "This server's control panel is locked",
      "detail": "The subscription has ended. Renew it first, then try again."
    },
    "server_paid_use_cancel": {
      "title": "This server has a paid subscription",
      "detail": "A server with a paid period can't be removed. Cancel the subscription instead."
    },
    "subscription_ended": {
      "title": "The subscription has ended",
      "detail": "Renew it first, then change the plan."
    },
    "subscription_incomplete": {
      "title": "The server is waiting for its first payment",
      "detail": "Pay the first period, then install bPanel on the server and activate it."
    },
    "subscription_revoked": {
      "title": "This server's licence is revoked",
      "detail": "It can't be renewed at checkout. Contact support."
    },
    "key_unavailable": {
      "title": "We can't show this activation key",
      "detail": "Reissue the key for this server and use the new one in the install command. The old key stops working."
    },
    "key_storage_unavailable": {
      "title": "Activation keys are unavailable right now",
      "detail": "We have a temporary problem storing keys. Try again shortly, and contact support if it continues."
    },
    "device_activation_disabled": {
      "title": "Activation with a code is turned off",
      "detail": "Install the server with its activation key instead. You'll find it on the server's page."
    },
    "license_service_unavailable": {
      "title": "The licence service is unavailable",
      "detail": "We couldn't reach the licence service. Try again in a few minutes."
    },
    "license_already_active": {
      "title": "This server is already activated",
      "detail": "It already has an active licence. Refresh the page."
    },
    "license_not_found": {
      "title": "We couldn't find this licence",
      "detail": "The server may have been deleted or moved to another account. Refresh the page."
    },
    "provider_unavailable": {
      "title": "The payment provider is unavailable",
      "detail": "We couldn't reach Dodo Payments, and nothing was charged. Try again in a few minutes."
    },
    "provider_rejected": {
      "title": "The payment provider declined the request",
      "detail": "Try again, and contact support if it happens again."
    },
    "document_not_available": {
      "title": "The invoice document isn't ready",
      "detail": "Dodo Payments issues it once the invoice is paid. If you just paid, wait a minute and try again."
    },
    "payment_not_set_up": {
      "title": "No saved payment method",
      "detail": "There's no saved payment method yet. It's saved with your first payment."
    },
    "payment_in_progress": {
      "title": "A payment is being processed",
      "detail": "Wait for the current payment to finish, then try again."
    },
    "price_not_available": {
      "title": "This price isn't available",
      "detail": "Refresh the page and try again, and contact support if it continues."
    },
    "price_not_synced": {
      "title": "This price isn't ready for payment yet",
      "detail": "We're setting it up with the payment provider. Try again in a few minutes."
    },
    "subscription_cancelling": {
      "title": "This subscription is cancelled and ends soon",
      "detail": "Undo the cancellation first, then change the plan."
    },
    "subscription_not_cancelling": {
      "title": "This subscription isn't cancelled",
      "detail": "There's no scheduled cancellation to undo. Refresh the page."
    },
    "subscription_not_changeable": {
      "title": "This subscription can't be changed now",
      "detail": "Its current state doesn't allow a change. Refresh the page and check it."
    },
    "signup_disabled": {
      "title": "Sign up is paused",
      "detail": "We aren't accepting new accounts right now. Try again later or contact us."
    },
    "too_many_attempts": {
      "title": "Too many attempts",
      "detail": "Wait 15 minutes, then try again."
    },
    "rate_limited": {
      "title": "Too many requests",
      "detail": "Wait a moment, then try again."
    },
    "ip_not_allowed": {
      "title": "Sign in from this address isn't allowed",
      "detail": "Your account only allows sign in from certain IP addresses. Ask the account owner or an admin to add yours."
    },
    "invalid_json": {
      "title": "The request was incomplete",
      "detail": "Refresh the page and try again."
    },
    "version_conflict": {
      "title": "This changed in the meantime",
      "detail": "Someone else changed it a moment ago. Refresh the page and try again."
    }
  },
  "fields": {
    "required": "This field is required",
    "too_long": "This is longer than allowed",
    "invalid_email": "Enter a valid email address",
    "password_too_short": "Use at least 10 characters",
    "passwords_mismatch": "The passwords don't match",
    "email_taken": "This email already has an account. Sign in instead.",
    "terms_required": "Accept the terms to continue",
    "country_not_supported": "Choose a Gulf country",
    "invalid_code": "That code isn't right. Try again.",
    "invalid": "This value isn't valid",
    "invalid_hostname": "Enter a full hostname, like server1.example.sa",
    "hostname_taken": "You already have a server with this hostname",
    "already_member": "One of these addresses is already on the team",
    "already_invited": "One of these addresses already has an open invitation",
    "too_many_emails": "Up to 10 addresses at a time",
    "too_short": "This is too short",
    "required_for_urgent": "Choose the affected server for urgent tickets",
    "diagnostics_unavailable": "No diagnostics available from this server",
    "too_many_files": "Up to 5 files",
    "file_too_large": "The file is too large",
    "file_type_not_allowed": "This file type isn't supported",
    "wrong_password": "The password is incorrect",
    "same_email": "This is your current email",
    "password_reused": "Choose a password different from the current one",
    "confirm_mismatch": "The text doesn't match",
    "preference_locked": "This notification is required for your role",
    "vat_sa_format": "15 digits, starting and ending with 3",
    "vat_ae_format": "15 digits starting with 100",
    "vat_15_digits": "Enter 15 digits",
    "vat_om_format": "OM followed by 10 digits",
    "vat_not_applicable": "This country has no VAT yet",
    "cr_sa_format": "10 digits",
    "postal_sa_format": "5 digits",
    "duplicate_email": "This email is already in the list",
    "billing_emails_limit": "Up to 5 addresses",
    "out_of_range": "This number is outside the allowed range",
    "limit_below_pack": "The limit must cover at least one top-up",
    "no_change": "This is the current plan"
  },
  "notFound": {
    "title": "Page not found",
    "body": "The link may be old or mistyped.",
    "home": "Back to overview",
    "code": "404"
  },
  "crash": {
    "title": "This page hit an error",
    "body": "We've logged it. Reload the page, and contact support if it happens again.",
    "reload": "Reload page",
    "home": "Back to overview"
  }
}
